/**
 * 倒计时
 * @param {number} times 必填 剩余时间秒数
 * @param {function} callbackFun  倒计时回调函数，返回{day,hour,minute,second}
 * @param {string} timerKey 时间间隔函数名 非必填项 当一个页面多个倒计时需要传此值区分
 */
var timerObj = {};
export var countDown = function (times, callbackFun, timerKey) {
    if (times === void 0) { times = 0; }
    if (callbackFun === void 0) { callbackFun = function (obj) { }; }
    if (timerKey === void 0) { timerKey = "timer1"; }
    if (!times) {
        return false;
    }
    if (typeof timerObj[timerKey] != "undefined") {
        clearInterval(timerObj[timerKey]);
    }
    timerObj[timerKey] = setInterval(function () {
        var day = 0, hour = 0, minute = 0, second = 0;
        if (times > 0) {
            day = Math.floor(times / (60 * 60 * 24));
            hour = Math.floor(times / (60 * 60)) - day * 24;
            minute = Math.floor(times / 60) - day * 24 * 60 - hour * 60;
            second =
                Math.floor(times) - day * 24 * 60 * 60 - hour * 60 * 60 - minute * 60;
        }
        callbackFun({ day: day, hour: hour, minute: minute, second: second });
        if (times >= 1) {
            times--;
        }
        else {
            clearInterval(timerObj[timerKey]);
        }
    }, 1000);
};
